module.exports = "<table style=\"border:1px solid black;\">\n    <tr style=\"border:1px solid black;\" *ngFor=\"let data1 of data\"><label style=\"padding: .8em;\">Voltage</label> \n      <th style=\"border:1px solid black;\" style=\"padding: .8em;\">{{data1.voltage}}</th>\n      <label style=\"padding: .8em;\">Fuel</label> <td style=\"border:1px solid black;\" style=\"padding: .8em;\">{{data1.fuel}}</td>\n    </tr>\n  </table>\n"


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/show-caliberation/show-caliberation.component.html
// module id = ../../../../../src/app/show-caliberation/show-caliberation.component.html
// module chunks = main